<template>
  <div class="container">
    <!--banner-->
    <div class="cardShow pc">
      <el-carousel
        class="cardShowban"
        height="625px"
        ref="cardShow"
        indicator-position="outside"
        :interval="3000"
        arrow="never"
      >
        <el-carousel-item>
          <img src="@/view/images/banner1.jpg" class="bannericon" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="@/view/images/banner2.jpg" class="bannericon" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="@/view/images/banner3.jpg" class="bannericon" />
        </el-carousel-item>
        <!-- 如果需要导航按钮 -->
        <div class="bannerbtn">
          <ul class="bt-a">
            <div class="bt-b" @click="arrowClick('left')"></div>
          </ul>
          <ul class="bt-k">
            <div class="bt-f boya" @click="arrowClick('right')"></div>
          </ul>
        </div>
        <div class="bka">
          <div class="bka_a fl">
            <a href="#">
              <img src="@/view/images/y4.png" />
              <p><span>企业使命</span>助力印刷企业步入数字化、智能化</p>
              <div class="clearfix"></div>
            </a>
          </div>
          <div class="bka_a fl">
            <a href="#">
              <img src="@/view/images/y5.png" />
              <p>
                <span>掌上互联</span
                >印刷工厂可视化，实现设备端、移动端、云端数据互联
              </p>
              <div class="clearfix"></div>
            </a>
          </div>
          <div class="bka_a fl">
            <a href="#">
              <img src="@/view/images/y6.png" />
              <p><span>管家服务</span>时刻监测分析，助您降本增效</p>
              <div class="clearfix"></div>
            </a>
          </div>
          <div class="bka_a fl">
            <a href="#">
              <img src="@/view/images/y7.png" />
              <p><span>课程培训</span>行业专家在线授课、解惑</p>
              <div class="clearfix"></div>
            </a>
          </div>
          <div class="clearfix"></div>
        </div>
      </el-carousel>
    </div>
    <div class="cardShow mob mobban">
      <el-carousel
        class="cardShowban"
        height="225px"
        ref="cardShow1"
        :interval="3000"
        arrow="never"
      >
        <el-carousel-item>
          <img src="@/view/images/sjbanner1.jpg" class="bannericon" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="@/view/images/sjbanner2.jpg" class="bannericon" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="@/view/images/sjbanner3.jpg" class="bannericon" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div class="keyword pc">
      <div class="commen">
        <p>
          热门关键词：印刷工业互联网，印刷数字化
          ，色彩管理，印刷数字化工厂
        </p>
      </div>
    </div> -->
    <!--4大优势-->
    <div class="ys">
      <div class="commen">
        <div class="bt reveal-homescale" style="margin-bottom: 40px;">
          <h6>印工社四大优势</h6>
          <img src="@/view/images/y8.png" />
        </div>
        <div class="ysahome">
          <div class="ysaa fl reveal-homescale">
            <div class="ysaa_t">
              <img src="@/view/images/y1.jpg" />
            </div>
            <div class="ysaa_w">
              <h6>印刷行业经验<br />业内资深专家</h6>
              <p>
                视觉机器人专家<br />印刷系统应用专家<br />色彩管理专家<br />......
              </p>
            </div>
          </div>
          <div class="ysaa fl reveal-homescale">
            <div class="ysaa_t">
              <img src="@/view/images/y2.jpg" />
            </div>
            <div class="ysaa_w">
              <h6>智能研究院<br />科研基地等</h6>
              <p>
                印工社有智能研究院<br />科研成果实训基地<br />全国高校产学研中心<br />......
              </p>
            </div>
          </div>
          <div class="ysaa fl reveal-homescale">
            <div class="ysaa_t">
              <img src="@/view/images/y3.jpg" />
            </div>
            <div class="ysaa_w">
              <h6>打造印刷工业互联网<br />服务平台</h6>
              <p>
                打造印刷工业互联网服务平台<br />助力印刷企业实现全流程色彩管理和智能化<br />工厂的升级<br />......
              </p>
            </div>
          </div>
          <div class="ysaa fl reveal-homescale">
            <div class="ysaa_t">
              <img src="@/view/images/y4.jpg" />
            </div>
            <div class="ysaa_w">
              <h6>印刷技术和管理等<br />专业课程提供</h6>
              <p>
                供印刷技术和管理等方面的专业课程<br />帮助印刷企业稳步实现数字化、智能化<br />......
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--印刷管家服务解决方案-->
    <div class="jj">
      <div class="commen1">
        <div class="bt reveal-homescale">
          <h6 style="color: #fff;">印刷管家服务解决方案</h6>
          <img src="@/view/images/y9.png" />
        </div>
        <div class="jja">
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y11.png" />
              <img class="tb" src="@/view/images/y11-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>色彩管理技术</h6>
              <p>Color management <br />technology</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y12.png" />
              <img class="tb" src="@/view/images/y12-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>视觉机器人技术</h6>
              <p>Vision robot technology</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y13.png" />
              <img class="tb" src="@/view/images/y13-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>印刷管家APP</h6>
              <p>Printing Manager app</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y14.png" />
              <img class="tb" src="@/view/images/y14-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>追样数据采集</h6>
              <p>Sampling data <br />collection</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y15.png" />
              <img class="tb" src="@/view/images/y15-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>制版数据采集</h6>
              <p>Plate making data <br />acquisition</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y16.png" />
              <img class="tb" src="@/view/images/y16-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>印张数据采集</h6>
              <p>Print data acquisition</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y17.png" />
              <img class="tb" src="@/view/images/y17-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>质量评测报告</h6>
              <p>Quality evaluation <br />report</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y18.png" />
              <img class="tb" src="@/view/images/y18-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>设备运维管理</h6>
              <p>Equipment operation & <br />maintenance management</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="jjaa fl">
            <div class="jjaa_w fl">
              <img class="ta" src="@/view/images/y19.png" />
              <img class="tb" src="@/view/images/y19-1.png" />
            </div>
            <div class="jjaa_t fl">
              <h6>专业培训赋能</h6>
              <p>Professional training <br />empowerment</p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="jj_m">
          <a @click="TOsolution" style="cursor:pointer">了解更多</a>
        </div>
      </div>
    </div>
    <!--印刷数字化智能工厂解决方案-->
    <div class="ysx">
      <div class="commen1">
          <div class="bt reveal-solutiontop">
            <h6>模块内容</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="ysxa">
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y7.jpg" />
              <div class="ysb_w">
                <h6>ERP企业资源计划系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>ERP企业资源计划系统</h6>
                  <p>
                    提供跨地区、跨部门甚至跨公司整合实时信息的企业管理信息系统。实现了企业内部资源和企业相关的外部资源的整合。通过软件把企业的人、财、物、产、供销及相应的物流、信息流、资金流、管理流、增值流等紧密地集成起来实现资源优化和共享。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y9.jpg" />
              <div class="ysb_w">
                <h6>APS高级计划与排程</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>APS高级计划与排程</h6>
                  <p>
                    解决顺序和调度的优化问题，助力企业提升项目管理与项目制造效率，优化关键链资源配置，降低综合成本与交付周期。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y43.jpg" />
              <div class="ysb_w">
                <h6>CRM客户资源管理</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>CRM客户资源管理</h6>
                  <p>
                    CRM客户关系管理系统，是指利用软件、硬件和网络技术，为企业建立一个客户信息收集、管理、分析和利用的信息系统。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y8.jpg" />
              <div class="ysb_w">
                <h6>BI商业智能</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>BI商业智能</h6>
                  <p>
                    用现代数据仓库技术、线上分析处理技术、数据挖掘和数据展现技术进行数据分析以实现商业价值。通过应用基于事实的支持系统来辅助商业决策的制定。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y10.jpg" />
              <div class="ysb_w">
                <h6>PLM产品生命周期管理</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>PLM产品生命周期管理</h6>
                  <p>
                    应用于在单一地点的企业内部、分散在多个地点的企业内部，以及在产品研发领域具有协作关系的企业之间的，支持产品全生命周期的信息的创建、管理、分发和应用的一系列应用解决方案，能够集成与产品相关的人力资源、流程、应用系统和信息。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y11.jpg" />
              <div class="ysb_w">
                <h6>CMS色彩管理系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>CMS色彩管理系统</h6>
                  <p>
                    在色彩失真最小的前提下，将颜色信息从一个色彩空间转换到另一个色彩空间的过程。目的是保证同样的颜色信息从输入到显示、输出整个过程中表现的外观尽可能相同，最终达到原稿与复制品的色彩一致性匹配。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y15.jpg" />
              <div class="ysb_w">
                <h6>MES制造执行系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>MES制造执行系统</h6>
                  <p>
                    通过信息传递对从订单下达到产品完成的整个生产过程进行优化管理。并对实时事件及时做出反应、报告，并用当前的准确数据对它们进行指导和处理。通过双向的直接通讯在企业内部和整个产品供应链中提供有关产品行为的关键任务信息。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y12.jpg" />
              <div class="ysb_w">
                <h6>WMS仓储管理系统</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>WMS仓储管理系统</h6>
                  <p>
                    一个实时的计算机软件系统，它能够按照运作的业务规则和运算法则，对信息、资源、行为、存货和分销运作进行更完美地管理，提高效率。管理仓库作业的结果记录、核对和管理，并对仓库作业过程的指导和规范。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y13.jpg" />
              <div class="ysb_w">
                <h6>QMS 质量管理体系</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>QMS 质量管理体系</h6>
                  <p>
                    制定质量方针、目标以及质量策划、质量控制、质量保证和质量改进等活动。实现质量管理的方针目标，有效地开展各项质量管理活动。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y44.jpg" />
              <div class="ysb_w">
                <h6>CPS感知设备</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>CPS感知设备</h6>
                  <p>
                    CPS是在环境感知的基础上，深度融合计算、通信和控制能力的可控可信可扩展的网络化物理设备系统。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y14.jpg" />
              <div class="ysb_w">
                <h6>IIOT工业物联设备</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>IIOT工业物联设备</h6>
                  <p>
                    将具有感知、监控能力的各类采集、控制传感器或控制器，以及移动通信、智能分析等技术不断融入到工业生产过程各个环节，从而大幅提高制造效率，改善产品质量，降低产品成本和资源消耗，最终实现将传统工业提升到智能化的新阶段。从应用形式上，工业物联网的应用具有实时性、自动化、嵌入式(软件)、安全性、和信息互通互联性等特点。
                  </p>
                </div>
              </div>
            </div>
            <div class="ysb fl reveal-solutiontop">
              <img src="@/view/images/y45.jpg" />
              <div class="ysb_w">
                <h6>AIDS扫码设备</h6>
              </div>
              <div class="ysc">
                <img src="@/view/images/y16.jpg" />
                <div class="ysc_w">
                  <h6>AIDS扫码设备</h6>
                  <p>在工业互联网中频繁使用到的各类扫码设备。</p>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- <div class="jj_m"><a @click="TOsolution">了解更多</a></div> -->
          <div class="clearfix"></div>
      </div>
    </div>
    <!--印工社智能工厂-->
    <div class="zngc">
      <img src="@/view/images/gif.gif" />
    </div>
    <!--帮助印刷企业创造利润-->
    <div class="bkb">
      <div class="commen">
        <div class="bt reveal-homescale">
          <h6>帮助印刷企业增加利润</h6>
          <img src="@/view/images/y8.png" />
        </div>
        <div class="bkba reveal-homescale">
          <img class="pc" src="@/view/images/y17.jpg" />
          <img class="mob" src="@/view/images/y20.jpg" />
        </div>
      </div>
    </div>
    <!--新闻-->
    <!-- <div class="xw">
      <div class="commen">
        <div class="bt reveal-homescale">
          <h6>资讯</h6>
          <img src="@/view/images/y8.png">
        </div>
        <div class="xwa reveal-homescale">
          <p :class="xwcid == 1 ? 'on' : ''" @mouseenter="xwc(1)"><a href="#">企业动态</a></p>
          <p :class="xwcid == 2 ? 'on' : ''" @mouseenter="xwc(2)"><a href="#">行业快报</a></p>
          <p :class="xwcid == 3 ? 'on' : ''" @mouseenter="xwc(3)"><a href="#">深度阅读</a></p>
          <div class="xwa_m"><a href="#">了解更多</a></div>
          <div class="clearfix"></div>
        </div>
        <div class="xwb">
          <div class="xwc" v-if="xwcid == 1">
            <div class="xwca fl">
              <a href="#">
                <div class="xwca_t">
                  <img src="@/view/images/y18.jpg">
                  <div class="xwca_rq">
                    <span>1</span>2021.05
                  </div>
                </div>
                <div class="xwca_w">
                  <h6>印刷智能化的简要定义</h6>
                  <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
            <div class="xwcb fr">
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="xwc" v-else-if="xwcid == 2">
            <div class="xwca fl">
              <a href="#">
                <div class="xwca_t">
                  <img src="@/view/images/y18.jpg">
                  <div class="xwca_rq">
                    <span>20</span>2021.05
                  </div>
                </div>
                <div class="xwca_w">
                  <h6>印刷智能化的简要定义</h6>
                  <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
            <div class="xwcb fr">
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="xwc" v-else>
            <div class="xwca fl">
              <a href="#">
                <div class="xwca_t">
                  <img src="@/view/images/y18.jpg">
                  <div class="xwca_rq">
                    <span>30</span>2021.05
                  </div>
                </div>
                <div class="xwca_w">
                  <h6>印刷智能化的简要定义</h6>
                  <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
            <div class="xwcb fr">
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
              <div class="xwcba">
                <a href="#">
                  <div class="xwcba_a fl"><span>19</span>2021.05</div>
                  <div class="xwcba_b fl">
                    <h6>印刷智能化的简要定义</h6>
                    <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                  </div>
                  <img src="@/view/images/y21.png">
                  <div class="clearfix"></div>
                </a>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div> -->
    <!--案例-->
    <!-- <div class="al">
      <div class="commen">
        <div class="bt reveal-homescale">
          <h6>案例</h6>
          <img src="@/view/images/y8.png">
        </div>
        <div class="ala pc reveal-homescale">
          <div class="alb">
            <el-carousel :interval="3000" type="card" indicator-position="none" arrow="never" height="280px">
              <el-carousel-item>
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="ala mob reveal-homescale">
          <div class="swiper-container sjbannerbox" id="swiper3">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="swiper-slide">
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="swiper-slide">
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="swiper-slide">
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="swiper-slide">
                <div class="alc fl">
                  <div class="ald">
                    <a href="#">
                      <img src="@/view/images/y22.png">
                      <h6>一瞬网络 / 青岛市</h6>
                      <p>青岛一瞬网络科技是国家级高新技术企业<br>主要为客户提供网络策划/网站建设/营销型网站建设/外贸网站建设/App开发等服务</p>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div style="height: 80px;"></div>
    <!-- <div class="bkc">
      <div class="commen1">
        <div class="bkca reveal-homescale">
          <h5>受信通院认可的<br />印刷行业工业互联网平台</h5>
          <p>印刷行业协会推荐单位</p>
          <p>人民日报、海尔、青啤等战略合作伙伴</p> -->
          <!-- <h6><a href="#">立即使用</a></h6> -->
          <!--链接后台登录页面-->
        <!-- </div>
      </div>
    </div> -->
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

export default {
  name: 'homeName',
  data() {
    return {
      xwcid: 1,
    };
  },
  methods: {
    init() {},
    xwc(id) {
      const _this = this;
      _this.xwcid = id;
    },
    arrowClick(val) {
      if (val === 'right') {
        this.$refs.cardShow.next();
      } else {
        this.$refs.cardShow.prev();
      }
    },
    TOsolution() {
      this.$router.push('solution?navaa=1');
    },
    TOsolution1() {
      this.$router.push('solution1?navaa=1');
    },
  },
  mounted() {
    this.$nextTick(() => {
      const _this = this;
      _this.mySwiper2 = new Swiper('#swiper3', {
        // loop: true,
        slidesPerView: 1.7,
        centeredSlides: true,
        observer: true,
      });
    });
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
<style scoped>
/*@import "../style/ygs.css";*/
.ysaa fl reveal-homescale {
  margin: 0 auto !important;
}
</style>
<style scoped>
.cardShow {
  width: 100%;
  position: relative;
}
.bannerbtn {
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
}
.jj_m {
  margin-bottom: 42px;
}

.alc {
  background: white;
}

.bka {
  z-index: 999;
}

.navc {
  border: 1px solid #f1f1f1;
}

.sjbannerbox {
  height: 200px;
  width: 100%;
}

.mobban {
  margin-top: 70px;
}

.pc .bannericon {
  width: 100% !important;
}
.mob .bannericon {
  width: 100% !important;
}
.mob,
.mob .alc {
  width: 100%;
  height: 200px;
}
</style>
<style>
.bannerboxli {
  width: 100%;
  overflow: hidden;
}

.cardShow .el-carousel__indicators--horizontal {
  width: 100% !important;
  position: absolute !important;
  bottom: 20% !important;
  left: 0 !important;
  transform: translateX(0) !important;
  z-index: 99 !important;
  text-align: center;
}

.cardShow .el-carousel__button {
  cursor: pointer;
  width: 7px;
  height: 7px;
  margin: 0 2.5px;
  float: left;
  position: relative;
  transition: all ease 0 0.35s;
  background-color: #fff;
  border-radius: 50%;
  opacity: 1;
  transition: all ease 0.35s;
}

.cardShow .el-carousel__indicator.is-active button {
  background-color: #f6b415;
  width: 30px;
  border-radius: 20px;
}

.mobban .el-carousel__indicators--outside {
  bottom: 0% !important;
}

.flip {
  position: absolute !important;
  bottom: 16% !important;
  left: 50% !important;
  margin-left: -35px !important;
  text-align: center !important;
}

.flip .swiper-pagination-bullet {
  cursor: pointer !important;
  width: 7px !important;
  height: 7px !important;
  margin: 0 2.5px !important;
  float: left !important;
  position: relative !important;
  transition: all ease 0.35s !important;
  background-color: #fff !important;
  background: #fff !important;
  border-radius: 50% !important;
  opacity: 1 !important;
}

.flip .swiper-pagination-bullet-active {
  background-color: #f6b415 !important;
  width: 30px !important;
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue